module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "pagexix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/07_Contents#ack",
      "id": "ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "padding-bottom": "1em"
    }
  }, [_vm._v("My deep thanks to the many people involved in the preparation of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Donald Manildi, Curator of the International Piano Archives at Maryland (University of Maryland, College Park) graciously hosted the major part of the research activity, sharing generously his vast knowledge and experience. Akiko Nakanishi, a Doctoral candidate in Piano Performance at the university, provided substantial assistance in the research at the Archives with a radiance of mind and spirit. M. Claire Ingalls crystallized the form the book would take. I thank her heartily for conceiving the idea that prevailed.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The Mozart scholar, Dr. Kathryn Libin, consulted at strategic points in the development of the manuscript to my great benefit. Lisbet Thew, the Swiss musicologist, structured the diverse elements of the book, and conducted painstaking research into a question arising out of the work on the "), _c('em', [_vm._v("Christmas Oratorio")]), _vm._v(". Hilary Matzinger kindly combined her fine knowledge of music with her abundant technological and linguistic skills to collaborate on the final preparation of the manuscript. I also give special thanks to my production editor, Lynn Zelem, for her excellent work on a not uncomplicated project.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Ned Quist, Director of the Arthur Friedheim Library of the Peabody Institute of the Johns Hopkins University, and his staff, responded with expertise to questions big and small. Patricia Elliott Stroh, Curator of the Ira F. Brilliant Center for Beethoven Studies in San Jose, California, was of enormous help in identifying the sketches for Beethoven’s Tenth Symphony.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Claude Frank, Richard Goode, Walter Hautzig, and Maurice Hinson took time from their many professional obligations to give inspiring interviews, endorsements, and suggestions. Dr. Vincent Fitzpatrick gave me valuable advice relating to publication matters.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "pagexx"
    }
  }, [_vm._v("For intensifying a sense of “family,” I also thank Konrad’s many friends, students, and colleagues who wrote letters, contributed materials, and unanimously applauded the planned publication of this volume. Finally, to my son, Jay Gillen, for his unfailing enthusiasm for Dr. Wolff’s writing, for his consummate scholarship in numerous consultations, and for his encouragement of this project from the very beginning.")])]), _c('a', {
    attrs: {
      "id": "pagexx"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-febad788","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/11_Ack.vue
// module id = 90
// module chunks = 0